import { INSIGHT_CATEGORY } from "../Types/account";

export const mapInsightCategoryToType = (
  category: INSIGHT_CATEGORY
): "ACCOUNT_INSIGHT" | "INDUSTRY_INSIGHT" | "ASSET_INSIGHT" => {
  switch (category) {
    case INSIGHT_CATEGORY.ACCOUNT:
      return "ACCOUNT_INSIGHT";
    case INSIGHT_CATEGORY.INDUSTRY:
      return "INDUSTRY_INSIGHT";
    case INSIGHT_CATEGORY.ASSET:
      return "ASSET_INSIGHT";
  }
};
